module.exports = __webpack_public_path__ + "img/OfficialAccount.b3d86054.png";